<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Discount') }}</legend>
                            <checkbox-input label="enabled" v-model="form.enabled" :error="form.errors.enabled" />
                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                            <select-input label="discount_type" v-model="form.discount_type" :error="form.errors.discount_type">
                                <option :value="null">{{ __('Bitte wählen') }}</option>
                                <option :value="k" v-for="(v, k) in discountTypeOptions">{{ v }}</option>
                            </select-input>
                            <textarea-input label="description" v-model="form.description" :error="form.errors.description" />
                            <text-input type="number" step=".0001" label="amount" v-model="form.amount" :error="form.errors.amount" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Regeln') }}</legend>
                            <div class="row row-cols-1 row-cols-sm-2">
                                <div class="col">
                                    <price-input label="Mindestbestellwert" v-model="form.min_order_amount" :error="form.errors.min_order_amount" />        
                                </div>
                                <div class="col">
                                    <price-input label="Maximalbestellwert" v-model="form.max_order_amount" :error="form.errors.max_order_amount" />        
                                </div>
                                <div class="col">
                                    <price-input label="Mindestumsatz gesamt" v-model="form.min_total_revenue" :error="form.errors.min_total_revenue" />
                                </div>
                                <div class="col">
                                    <price-input label="Maximalumsatz gesamt" v-model="form.max_total_revenue" :error="form.errors.max_total_revenue" />
                                </div>
                                <div class="col">
                                    <text-input type="date" label="Gültig ab" v-model="form.valid_from" :error="form.errors.valid_from" />
                                </div>
                                <div class="col">
                                    <text-input type="date" label="Gültig bis" v-model="form.valid_until" :error="form.errors.valid_until" />
                                </div>
                            </div>

                            <multi-select-input
                                v-model="form.customers" 
                                value-format="object"
                                :multiple="true" 
                                :async="true"
                                :load-options="loadCustomers" 
                                :placeholder="__('Search')" 
                                :label="__('Customers')"
                                :error="form.errors.customers"
                                />

                            <multi-select-input
                                v-model="form.exclude_customers" 
                                value-format="object"
                                :multiple="true" 
                                :async="true" 
                                :load-options="loadCustomers" 
                                :placeholder="__('Search')" 
                                :label="__('Exclude Customers')"
                                :error="form.errors.exclude_customers"
                                />

                            <multi-select-input
                                v-model="form.products" 
                                value-format="object"
                                :multiple="true" 
                                :async="true" 
                                :load-options="loadProducts" 
                                :placeholder="__('Search')" 
                                :label="__('Products')"
                                :error="form.errors.products"
                                />

                            <multi-select-input
                                v-model="form.exclude_products" 
                                value-format="object"
                                :multiple="true" 
                                :async="true" 
                                :load-options="loadProducts" 
                                :placeholder="__('Search')" 
                                :label="__('Exclude Products')"
                                :error="form.errors.exclude_products"
                                />

                            <multi-select-input
                                v-model="form.categories" 
                                value-consists-of="ALL"
                                :flat="true"
                                sort-value-by="INDEX"
                                :multiple="true" 
                                :options="categoryOptions" 
                                :placeholder="__('Search')"
                                :label="__('Categories')"
                                :error="form.errors.categories"
                                />

                            <multi-select-input
                                v-model="form.exclude_categories" 
                                value-consists-of="ALL"
                                :flat="true"
                                sort-value-by="INDEX"
                                :multiple="true" 
                                :options="categoryOptions" 
                                :placeholder="__('Search')"
                                :label="__('Exclude Categories')"
                                :error="form.errors.exclude_categories"
                                />

                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="discount">
                    {{ __('Löschen') }}
                </button>
            </div>

        </div>

    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';



    export default {
        props: [
            'form',
            'discount',
            'categoryTree',
            'discountTypeOptions',
        ],
        data() {
            return {
                options: null,
                categoryOptions: this.categoryTree,
            }
        },
        components: {
            TextInput,
            PriceInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
            MultiSelectInput,
        },
        watch: {
        },
        methods: {
            loadCustomers( { action, searchQuery, callback }) {
                axios.get(this.route('admin.discounts.search', {type: 'customers'}), {params: {search: searchQuery}})
                        .then(response => callback(null, response.data));
            },
            loadProducts( { action, searchQuery, callback }) {
                axios.get(this.route('admin.discounts.search', {type: 'products'}), {params: {search: searchQuery}})
                        .then(response => callback(null, response.data));
            },
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.discounts.destroy', this.discount));
                }
            },
        },
    }
</script>
